/* eslint-disable react-hooks/exhaustive-deps */
import {
  Autocomplete,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  FormControlLabel,
  Grid2,
  IconButton,
  OutlinedInput,
  Radio,
  RadioGroup,
  Stack,
  Step,
  StepLabel,
  Stepper,
  TextField,
  Tooltip,
} from '@mui/material';
import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useForm, SubmitHandler } from 'react-hook-form';
import { makeStyles } from '@mui/styles';
import {
  ContentResponse,
  PreFinalFileDefaultValue,
  PreFinalFormFields,
} from '../../../../data/types/content.interface';
import { capitalize, isEmpty } from 'lodash';
import {
  CloseIcon,
  UsedIcon,
  UnusedIcon,
  FileDownloadIcon,
  DownIcon,
  UpIcon,
  NotInUseIcon,
  ViewIcon,
} from '../../../shared/components/AppIcons';
import { TagType } from '../../../../data/types/tags.interface';
import IdentityService from '../../../tags/identities/services/identity.services';
import LocationService from '../../../tags/locations/services/location.services';
import EventService from '../../../tags/events/services/event.services';
import AuthorService from '../../../tags/authors/services/author.services';
import ThemeService from '../../../tags/theme/services/theme.services';
import BrandService from '../../../tags/brands/services/brand.services';
import PersonService from '../../../tags/persons/services/person.services';
import moment from 'moment';
import theme from '../../../../core/theme';
import ConfirmationDialog from '../../../shared/components/ConfirmationDialog';
import ContentsService from '../../services/contents.services';
import VideoPlayer from '../../../shared/components/VideoPlayer';
import { useAuthentication } from '../../../auth/services/auth.provider';

const useStyles = makeStyles({
  paper: {
    minWidth: '927px',
    height: 'auto',
    borderRadius: '21px',
    boxShadow: 'rgba(242, 242, 242, 1)',
    '& .MuiInputBase-input, .MuiOutlinedInput-input': {
      font: 'Lato !important',
    },
  },
  header: {
    fontSize: '24px',
    verticalAlign: 'text-top',
  },
  close: {
    fontSize: '50px !important',
    color: '#5F6774 !important',
    '& path': {
      fill: `#2C2C2C !important`,
    },
  },
  progressBar: {
    '& .MuiSvgIcon-root': {
      color: '#4db193 !important',
    },
    '& .MuiStepLabel-label': {
      fontFamily: 'Lato !important',
    },
  },
  inputField: {
    margin: '11px 0px 11px 18px',
    '& .MuiStack-root': {
      width: '202px',
      border: '1px solid #E1E3E8',
      borderRadius: '4px',
    },
  },
  file: {
    '& .MuiStack-root': {
      border: '1px solid #E1E3E8',
      borderRadius: '4px',
    },
    '& input': {
      height: '40px',
      fontFamily: 'Lato',
      padding: '0 !important',
      paddingLeft: '14px !important',
    },
    '& .MuiInput-underline:before': {
      borderBottom: 'none',
    },
    '& .MuiInput-underline:after': {
      borderBottom: 'none',
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled, .Mui-error):before': {
      borderBottom: 'none',
    },
  },
  textField: {
    '& .MuiInputBase-root': {
      border: '1px solid #E1E3E8',
      borderRadius: '4px',
      padding: '4px 8px',
      height: '40px !important',
      fontFamily: 'Lato !important',
    },
    '& .MuiInputBase-input': {
      padding: '6px 0',
    },
    '& .MuiInput-underline:before': {
      borderBottom: 'none',
    },
    '& .MuiInput-underline:after': {
      borderBottom: 'none',
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled, .Mui-error):before': {
      borderBottom: 'none',
    },
  },
  smallText: {
    fontSize: '12px',
    color: theme.palette.outlineInactive.main,
  },
  error: {
    color: '#F57570',
  },
  editDetails: {
    width: '135px',
    height: '38px',
    backgroundColor: '#F67570 !important',
    color: '#fff !important',
    fontSize: '18px !important',
    boxShadow: 'none !important',
    '& g path': {
      fill: '#ffffff !important',
    },
    '&.disable': {
      backgroundColor: '#848080 !important',
    },
  },
  cancel: {
    color: '#F67570 !important',
    marginRight: '24px !important',
    fontSize: '16px !important',
    fontFamily: 'Lato !important',
  },
  downIcon: {
    '& path': {
      fill: '#000 !important',
    },
  },
  link: {
    width: '95%',
    wordBreak: 'break-all',
  },
  input: {
    '& input': {
      height: '40px !important',
      borderRadius: '4px',
    },
  },
  path: {
    border: '1px solid #DE5852',
    borderRadius: '4px',
    wordBreak: 'break-all',
    width: '100%',
    height: '40px',
    alignItems: 'center',
  },
  wrapText: {
    '& input': {
      wordBreak: 'break-word',
    },
  },
  radioBtn: {
    '& span': {
      '& svg': {
        fill: '#E1E3E8 !important',
      },
    },
    '& .Mui-checked': {
      '& svg': {
        fill: '#30343F !important',
      },
    },
  },
  field: {
    '& .MuiAutocomplete-inputRoot': {
      minHeight: '40px !important',
      paddingRight: '0 !important',
    },
    '& .MuiInputBase-input': {
      padding: '6px 0',
    },
    '& .MuiInput-underline:before': {
      borderBottom: 'none',
    },
    '& .MuiInput-underline:after': {
      borderBottom: 'none',
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled, .Mui-error):before': {
      borderBottom: 'none',
    },
  },
  outlineInputField: {
    '& .MuiOutlinedInput-root': {
      minHeight: 40,
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#E1E3E8 !important',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#E1E3E8 !important',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#E1E3E8 !important',
      borderWidth: '1px !important',
    },
    '& .MuiOutlinedInput-input': {
      outline: 'none !important',
      textOverflow: 'ellipsis',
    },
  },
  overflow: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  dropdownIcon: {
    fontSize: '42px !important',
    '& path': {
      fill: '#5F6774 !important',
    },
  },
});

interface Props {
  setOpenDetailsModal: Dispatch<SetStateAction<boolean>>;
  id: number | null;
  setRefresh?: Dispatch<SetStateAction<boolean>>;
  setToasterMessage?: Dispatch<SetStateAction<string>>;
  disableEdit?: boolean;
  themeList: TagType[];
}

const steps = [
  'Raw Production',
  'Title, Type',
  'Tag and Link',
  'Upload Prod File',
  'Upload Pre Final File',
  'Final File',
];

const PreFinalFileContentDetails: React.FC<Props> = ({ setOpenDetailsModal, id, setRefresh, setToasterMessage, disableEdit, themeList }) => {
  const classes = useStyles();
  const { currentUser: user } = useAuthentication();
  const isAdmin = user?.role.name === 'admin';
  const isCreativeEditor = user?.role.name === 'creative_editor';
  const isContentSpecialist = user?.role.name === 'content_specialist';
  const {
    handleSubmit,
    register,
    setValue,
    formState: { errors },
    getValues,
  } = useForm<PreFinalFormFields>({
    defaultValues: PreFinalFileDefaultValue,
    mode: 'all',
  });
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [cont, setCont] = useState<ContentResponse | null>();
  const [title, setTitle] = useState('');
  const [topicList, setTopicList] = useState<TagType[]>([]);
  const [selectedTopics, setSelectedTopics] = useState<TagType[]>([]);
  const [subTopicList, setSubTopicList] = useState<TagType[]>([]);
  const [selectedSubTopics, setSelectedSubTopics] = useState<TagType[]>([]);
  const [brands, setBrands] = useState<TagType[]>([]);
  const [persons, setPersons] = useState<TagType[]>([]);
  const [identityList, setIdentityList] = useState<TagType[]>([]);
  const [locations, setLocations] = useState<TagType[]>([]);
  const [events, setEvents] = useState<TagType[]>([]);
  const [authors, setAuthors] = useState<TagType[]>([]);
  const [selectedBrands, setSelectedBrands] = useState<TagType[]>([]);
  const [selectedPersons, setSelectedPersons] = useState<TagType[]>([]);
  const [selectedIdentities, setSelectedIdentities] = useState<TagType[]>([]);
  const [selectedEvents, setSelectedEvents] = useState<TagType[]>([]);
  const [selectedLocations, setSelectedLocations] = useState<TagType[]>([]);
  const [selectedAuthors, setSelectedAuthors] = useState<TagType[]>([]);
  const [fileName, setFileName] = useState(cont?.filename || '');
  const [isDirtyFileName, setIsDirtyFileName] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState<boolean>(false);
  const [prodFile, setProdFile] = useState('');
  const [prodLink, setProdLink] = useState('');
  const [rawAsset, setRawAsset] = useState<string>('');
  const [usedOrUnused, setUsedOrUnused] = useState(cont?.edited);
  const [videoType, setVideoType] = useState(cont?.videoType || 'short');
  const [contentAccessLink, setContentAccessLink] = useState('');
  const [anchorEl, setAnchorEl] = React.useState(false);
  const [open, setOpen] = useState(false);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [selectedTheme, setSelectedTheme] = useState<TagType | null>(null);

  const theme = cont?.theme || cont?.themes?.find((t: TagType) => t.type === 'theme')?.name;

  const defaultThemeProps = {
    options: themeList,
    getOptionLabel: (option: TagType) => option.name,
  };

  const getAllThemes = async (type: string, theme: TagType[], topics?: TagType[]) => {
    if (type === 'topic') {
      const result = await ThemeService.get(type, theme);
      setTopicList(result);
    }
    if (type === 'sub-topic') {
      const result = await ThemeService.get(type, theme, selectedTopics);
      setSubTopicList(result);
    }
  };

  const getAllBrands = async () => {
    const result = await BrandService.get();
    if (result) {
      setBrands(result);
    }
  };

  const getAllPersons = async () => {
    const result = await PersonService.get();
    if (result) {
      setPersons(result);
    }
  };

  const getAllIdentity = async () => {
    const result = await IdentityService.get();
    if (result) {
      setIdentityList(result);
    }
  };

  const getAllLocations = async () => {
    const result = await LocationService.get();
    if (result) {
      setLocations(result);
    }
  };

  const getAllEvents = async () => {
    const result = await EventService.get();
    if (result) {
      setEvents(result);
    }
  };

  const getAllAuthors = async () => {
    const result = await AuthorService.get();
    if (result) {
      setAuthors(result);
    }
  };

  useEffect(() => {
    getAllBrands();
    getAllPersons();
    getAllIdentity();
    getAllLocations();
    getAllEvents();
    getAllAuthors();
  }, []);

  useEffect(() => {
    if (cont?.themes && cont?.themes?.length >= 0) {
      const theme = cont?.themes.filter((theme) => theme.type === 'theme');
      getAllThemes('topic', theme);
      getAllThemes('sub-topic', theme);
    }
  }, [cont]);

  useEffect(() => {
    if (selectedTopics.length > 0 && cont?.themes) {
      const theme = cont?.themes.filter((theme) => theme.type === 'theme');
      const topics = selectedTopics.length > 0 ? selectedTopics : [];
      getAllThemes('sub-topic', theme, topics);
    }
  }, [selectedTopics]);

  const getContentDetails = async (id: number) => {
    const content = await ContentsService.getDetails(id);
    if (content) {
      setCont(content);
      setTitle(content.title);
      setVideoType(content.videoType || 'short');
      setValue('title', content.title);
      setValue('fileName', content.filename);
      setValue('rawAsset', content.rawAsset);
      setValue('productionFile', content.productionFile);
      setValue('productionLink', content.productionLink);
      setFileName(content.filename);
      setRawAsset(content.rawAsset);
      setProdFile(content.productionFile);
      setProdLink(content.productionLink);
      setSelectedBrands(content.brands || []);
      setSelectedTopics(content.themes?.filter((theme) => theme.type === 'topic') || []);
      setSelectedSubTopics(content.themes?.filter((theme) => theme.type === 'sub-topic') || []);
      setSelectedPersons(content.personalities || []);
      setSelectedIdentities(content.identity_tags || []);
      setSelectedLocations(content.location_tags || []);
      setSelectedAuthors(content.authors || []);
      setSelectedEvents(content.event_tags || []);
      setUsedOrUnused(content.edited);
    }
  };

  const fetchRealContent = async (url: string) => {
    let contentUrl = '';
    if (url) {
      if (url.includes('localhost')) {
        const accessContent = await ContentsService.fetchRealS3Content(url);
        setContentAccessLink(accessContent.url);
      } else {
        contentUrl = await ContentsService.fetchRealDropboxContent(url);
        setContentAccessLink(contentUrl);
      }
    }
  };

  const getAccessLink = (url: string) => {
    const dropboxPath = url.split('/V2 Solutions Team')[1];
    return `https://www.dropbox.com/home/V2%20Solutions%20Team%2F${dropboxPath}`;
  };

  useEffect(() => {
    getContentDetails(Number(id));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (cont?.videoUrl) {
      fetchRealContent(cont?.videoUrl);
    }
  }, [cont]);

  const isDisabled = () => {
    return isEmpty(rawAsset) || isEmpty(prodFile) || isEmpty(prodLink);
  };

  const handleConfirm = async () => {
    try {
      if (isAdmin && (selectedTopics.length === 0 || selectedSubTopics.length === 0)) {
        setErrorMessage('Please fill the mandatory fields');
        return;
      }
      const params = {
        title,
        filename: fileName,
        brands: selectedBrands,
        themes: cont?.themes?.filter((theme) => theme.type === 'theme'),
        topics: selectedTopics,
        subTopics: selectedSubTopics,
        persons: selectedPersons,
        identities: selectedIdentities,
        locations: selectedLocations,
        events: selectedEvents,
        authors: selectedAuthors,
        rawAsset,
        videoType,
        usedOrUnused,
        productionFile: prodFile,
        productionLink: prodLink,
      };

      if (selectedTheme && cont?.themes?.filter((t) => t.type === 'theme').length === 0) {
        params.themes = [selectedTheme];
      }

      if (id && ((!isDisabled() && isAdmin) || isContentSpecialist || isCreativeEditor)) {
        const content = await ContentsService.updateContentDetails(id, 'pre_final', params);
        if (content) {
          setBrands(content.brands || []);
          setSelectedTopics(content.themes?.filter((theme) => theme.type === 'topic') || []);
          setSelectedSubTopics(content.themes?.filter((theme) => theme.type === 'sub-topic') || []);
          setSelectedPersons(content.personalities || []);
          setSelectedIdentities(content.identity_tags || []);
          setSelectedLocations(content.location_tags || []);
          setSelectedAuthors(content.authors || []);
          setSelectedEvents(content.event_tags || []);
        }
        if (setRefresh) {
          setRefresh(true);
        }
        setOpenDetailsModal(false);
      }
    } catch (error) {
      setErrorMessage(error?.response?.data[0]?.message || 'Please try again');
    }
  };

  const onSubmit: SubmitHandler<PreFinalFormFields> = async (form) => {
    setIsFormSubmitted(true);
    if (isDirtyFileName) {
      setShowConfirmationModal(true);
    } else handleConfirm();
    if (setToasterMessage) {
      setToasterMessage('Changes Saved Successfully');
    }
  };

  const handleTitleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value.endsWith('_Title_Pre Final')) {
      setTitle(e.target.value);
      setErrorMessage('');
    } else {
      setErrorMessage('Please enter title as per the naming convention');
    }
  };

  const handleFileName = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsDirtyFileName(true);
    if (e.target.value.endsWith('Pre Final')) {
      setFileName(e.target.value || '');
      setErrorMessage('');
    } else {
      setErrorMessage('Please enter file name as per the naming convention');
    }
  };

  const handleThemeChange = (e: React.SyntheticEvent<Element, Event>, values: TagType | null) => {
    setSelectedTheme(values);
  };

  const handleProductionFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (isEmpty(e.target.value)) {
      setValue('productionFile', e.target.value);
      setErrorMessage('Please add production file');
    } else {
      setProdFile(e.target.value);
      setErrorMessage('');
    }
  };

  const handleProdLinkChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (isEmpty(e.target.value)) {
      setValue('productionLink', e.target.value);
      setErrorMessage('Please add production file link');
    } else {
      setProdLink(e.target.value);
      setErrorMessage('');
    }
  };

  const handleTopicChange = (e: React.SyntheticEvent<Element, Event>, values: TagType[]) => {
    setSelectedTopics(values);
  };

  const handleSubTopicChange = (e: React.SyntheticEvent<Element, Event>, values: TagType[]) => {
    setSelectedSubTopics(values);
  };

  const handleVideoTypeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setVideoType((event.target as HTMLInputElement).value);
  };

  const handleBrandChange = (e: React.SyntheticEvent<Element, Event>, values: TagType[]) => {
    setSelectedBrands(values);
  };

  const handlePersonChange = (e: React.SyntheticEvent<Element, Event>, values: TagType[]) => {
    setSelectedPersons(values);
  };

  const handleIdentityChange = (e: React.SyntheticEvent<Element, Event>, values: TagType[]) => {
    setSelectedIdentities(values);
  };

  const handleLocationChange = (e: React.SyntheticEvent<Element, Event>, values: TagType[]) => {
    setSelectedLocations(values);
  };

  const handleEventChange = (e: React.SyntheticEvent<Element, Event>, values: TagType[]) => {
    setSelectedEvents(values);
  };

  const handleAuthorChange = (e: React.SyntheticEvent<Element, Event>, values: TagType[]) => {
    setSelectedAuthors(values);
  };

  const handleUsedOrUnused = (e: React.ChangeEvent<HTMLInputElement>) => {
    setUsedOrUnused(e.target.value);
  };

  return (
    <>
      <Dialog
        open
        aria-modal="true"
        role="dialog"
        onClose={() => setOpenDetailsModal(false)}
        PaperProps={{
          onClick: (e: any) => e.stopPropagation(),
          className: classes.paper,
        }}
      >
        <DialogTitle>
          <Grid2 container justifyContent="space-between">
            <Grid2>
              <span className={classes.header}>{`Content Creation Pre-Final File Details`}</span>
            </Grid2>
            <Grid2 container justifyContent="flex-end">
              <IconButton onClick={() => setOpenDetailsModal(false)} role="button" sx={{ padding: 0 }}>
                <CloseIcon viewBox="0 0 42 42" className={classes.close} />
              </IconButton>
            </Grid2>
          </Grid2>
          <Grid2>
            <Divider
              orientation="horizontal"
              flexItem
              sx={{
                backgroundColor: '#E1E3E8',
                paddingBottom: '1px',
              }}
            />
          </Grid2>
        </DialogTitle>

        <DialogContent sx={{ paddingBottom: '0px' }}>
          {errorMessage && errorMessage.length > 0 && (
            <Grid2 container justifyContent="center">
              <div className="text-danger mb-1 pb-5 text-center">{errorMessage}</div>
            </Grid2>
          )}
          <form onSubmit={handleSubmit(onSubmit)}>
            <Grid2 container direction="column" className={classes.progressBar}>
              <Stepper activeStep={5} alternativeLabel>
                {steps.map((label) => (
                  <Step key={label}>
                    <StepLabel>{label}</StepLabel>
                  </Step>
                ))}
              </Stepper>
            </Grid2>

            <Grid2 container direction="column" flexWrap="nowrap">
              <Grid2 container mt={4}>
                <Grid2 container>
                  <span className={classes.smallText}>
                    <VideoPlayer videoUrl={contentAccessLink || ''} thumbnail={cont?.thumbnail} />
                  </span>
                </Grid2>

                <Grid2 style={{ cursor: 'pointer' }} container direction="column" ml={3} width="23%">
                  <Grid2>
                    <span>Usage</span>
                  </Grid2>
                  <Grid2 container width="100%" justifyContent="space-between">
                    <Grid2 width="80%">
                      {usedOrUnused === 'Unused' ? (
                        <span>
                          <UnusedIcon viewBox="5 6 32 32" sx={{ fontSize: '42px' }} />
                          Not Used
                        </span>
                      ) : usedOrUnused === 'NotInUse' ? (
                        <span>
                          <NotInUseIcon viewBox="5 6 32 32" sx={{ fontSize: '42px' }} />
                          Not In Use
                        </span>
                      ) : (
                        <span>
                          <UsedIcon viewBox="5 6 32 32" style={{ fontSize: '42px' }} />
                          Used
                        </span>
                      )}
                    </Grid2>
                    <Grid2 width="20%">
                      <Button onClick={() => setAnchorEl(!anchorEl)}>
                        {anchorEl ? (
                          <UpIcon style={{ fontSize: '35px' }} className={classes.downIcon} />
                        ) : (
                          <DownIcon style={{ fontSize: '35px' }} className={classes.downIcon} />
                        )}
                      </Button>
                    </Grid2>
                  </Grid2>
                  {anchorEl && (
                    <FormControl>
                      <RadioGroup
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="controlled-radio-buttons-group"
                        value={usedOrUnused}
                        onChange={handleUsedOrUnused}
                      >
                        <Grid2 container direction="column">
                          <FormControlLabel
                            sx={{ ml: '4px' }}
                            className={classes.radioBtn}
                            value="Used"
                            control={<Radio />}
                            label="Used"
                          />
                          <FormControlLabel
                            sx={{ ml: '4px' }}
                            className={classes.radioBtn}
                            value="Unused"
                            control={<Radio />}
                            label="Not Used"
                          />
                          <FormControlLabel
                            sx={{ ml: '4px' }}
                            value="NotInUse"
                            control={<Radio />}
                            label="Not In Use"
                          />
                        </Grid2>
                      </RadioGroup>
                    </FormControl>
                  )}
                </Grid2>
              </Grid2>

              <Grid2 container direction="column">
                <span className={classes.smallText} style={{ color: 'black' }}>
                  Date Added: {moment(cont?.createdAt).format('YYYY-MM-DD')}
                </span>
                <span className={classes.smallText} style={{ color: 'black' }}>
                  Last Updated on Dropbox: {moment(cont?.lastUpdatedAt).format('YYYY-MM-DD')}
                </span>
              </Grid2>

              <Grid2 container mt={2} direction="column" width="100%">
                <Grid2>
                  <label>Pre-Final File*</label>
                </Grid2>
                <Grid2>
                  <input
                    {...register('fileName', { required: true })}
                    name="fileName"
                    id="fileName"
                    style={{ paddingLeft: '14px', borderRadius: '4px' }}
                    className={`form-control ${errors.fileName && 'is-invalid'}`}
                    onChange={(e) => handleFileName(e)}
                  />
                </Grid2>
                {isEmpty(getValues('fileName')) && (
                  <span className={`${classes.smallText} ${classes.error}`}>Filename can not be empty</span>
                )}
              </Grid2>

              <Grid2 container mt={1} direction="column" width="100%">
                <Grid2>
                  <label>Title*</label>
                </Grid2>
                <Grid2>
                  <input
                    {...register('title', { required: true })}
                    name="title"
                    id="title"
                    style={{ paddingLeft: '14px', borderRadius: '4px' }}
                    className={`form-control ${errors.title && 'is-invalid'}`}
                    onChange={(e) => handleTitleChange(e)}
                  />
                </Grid2>
                {isEmpty(getValues('title')) && (
                  <span className={`${classes.smallText} ${classes.error}`}>Title can't be empty</span>
                )}
              </Grid2>

              <Grid2 container>
                <Grid2 container direction="column" sx={{ width: '48%' }}>
                  {cont?.assetContentType && (
                    <Grid2 container direction="column" mt={1.5}>
                      <label>Content Type</label>
                      <FormControl>
                        <OutlinedInput
                          className={classes.outlineInputField}
                          placeholder="contentType"
                          value={`${capitalize(cont?.assetContentType.name)}`}
                        />
                      </FormControl>
                    </Grid2>
                  )}
                </Grid2>
                {cont?.assetContentType.name === 'video' && (
                  <Grid2 container direction="column" mt={1.5} ml={2} sx={{ width: '48%' }}>
                    <>
                      <label>Video Type*</label>
                      <FormControl>
                        <RadioGroup
                          aria-labelledby="demo-controlled-radio-buttons-group"
                          name="controlled-radio-buttons-group"
                          value={videoType}
                          onChange={handleVideoTypeChange}
                        >
                          <Grid2 container>
                            <FormControlLabel
                              value="long_original"
                              control={<Radio />}
                              className={classes.radioBtn}
                              label={
                                <Tooltip title="Original video clip">
                                  <span>Long Original</span>
                                </Tooltip>
                              }
                            />
                            <FormControlLabel
                              value="long_chopped"
                              control={<Radio />}
                              className={classes.radioBtn}
                              label={
                                <Tooltip title="Short videos made out of original clip">
                                  <span>Long Chopped</span>
                                </Tooltip>
                              }
                            />
                            <FormControlLabel
                              value="short"
                              control={<Radio />}
                              className={classes.radioBtn}
                              label={
                                <Tooltip title="Original short video clip">
                                  <span>Short</span>
                                </Tooltip>
                              }
                            />
                          </Grid2>
                        </RadioGroup>
                      </FormControl>
                    </>
                  </Grid2>
                )}
              </Grid2>

              <Grid2 container direction="column" mt={2}>
                <label>Theme</label>
                {theme ? (
                  <FormControl>
                    <OutlinedInput
                      className={classes.outlineInputField}
                      placeholder="Theme"
                      value={theme}
                    />
                  </FormControl>
                ) : (
                  <Stack spacing={1} sx={{ width: 300 }}>
                    <Autocomplete
                      {...defaultThemeProps}
                      id="auto-highlight"
                      autoHighlight
                      value={selectedTheme}
                      onChange={handleThemeChange}
                      className={`form-control ${errors.theme && 'is-invalid'}`}
                      renderInput={(params) => <TextField {...params} label="" variant="standard" />}
                    />
                  </Stack>)
                }
              </Grid2>

              <Grid2 container mt={2} flexWrap="nowrap" width="101%">
                <Grid2 container direction="column" sx={{ width: '49%' }}>
                  <label>Category</label>
                  <FormControl>
                    <OutlinedInput
                      className={classes.outlineInputField}
                      placeholder="category"
                      value={cont?.category}
                    />
                  </FormControl>
                </Grid2>
                <Grid2 container direction="column" ml="9px" sx={{ width: '49%' }}>
                  <label>Sub Category</label>
                  <FormControl>
                    <OutlinedInput
                      className={classes.outlineInputField}
                      placeholder="sub category"
                      value={cont?.subCategory}
                    />
                  </FormControl>
                </Grid2>
              </Grid2>

              <Grid2 container direction="column" mt={2}>
                <label>Main Folder</label>
                <FormControl>
                  <OutlinedInput
                    className={classes.outlineInputField}
                    placeholder="main folder"
                    value={cont?.mainFolder}
                  />
                </FormControl>
              </Grid2>

              <Grid2 container direction="column" mt={2}>
                <label>Sub Folder</label>
                <FormControl>
                  <OutlinedInput
                    className={classes.outlineInputField}
                    placeholder="sub folder"
                    value={cont?.subFolder}
                  />
                </FormControl>
              </Grid2>

              <Grid2 container mt={2} direction="column" width="100%">
                <Grid2>
                  <label>Raw Asset Link*</label>
                </Grid2>
                <Grid2 container>
                  <Grid2 width="95%" className={classes.file}>
                    <input
                      {...register('rawAsset', { required: isAdmin })}
                      name="rawAsset"
                      id="rawAsset"
                      value={rawAsset}
                      style={{ paddingLeft: '14px', height: '40px !important' }}
                      className={`form-control ${errors.rawAsset && 'is-invalid'}`}
                      onChange={(e) => {
                        setValue('rawAsset', e.target.value);
                        setRawAsset(e.target.value);
                      }}
                      readOnly={isContentSpecialist}
                    />
                  </Grid2>
                  <Grid2 container justifyContent="flex-end" width="5%">
                    <a href={getValues('rawAsset')} target="_blank" rel="noreferrer" aria-disabled={isEmpty(rawAsset)}>
                      <ViewIcon viewBox="0 0 42 42" />
                    </a>
                  </Grid2>
                </Grid2>
                {isEmpty(rawAsset) && isFormSubmitted && isAdmin && (
                  <span className={`${classes.smallText} ${classes.error}`}>Raw Asset can not be empty</span>
                )}
              </Grid2>

              <Grid2 container mt={2} direction="column">
                <Grid2>
                  <label>Production File Name*</label>
                </Grid2>
                <Grid2 className={classes.input}>
                  <input
                    {...register('productionFile', { required: isAdmin ? true : false })}
                    name="productionFile"
                    id="productionFile"
                    style={{ paddingLeft: '14px' }}
                    className={`form-control ${errors.productionFile && 'is-invalid'}`}
                    onChange={(e) => handleProductionFileChange(e)}
                    readOnly={isContentSpecialist}
                  />
                </Grid2>
                {isEmpty(getValues('productionFile')) && isFormSubmitted && isAdmin && (
                  <span className={`${classes.smallText} ${classes.error}`}>Production File name can not be empty</span>
                )}
              </Grid2>

              <Grid2 container direction="column" sx={{ cursor: 'pointer' }} mt={2} mb={2}>
                <Grid2>
                  <label>Production File Link*</label>
                </Grid2>
                <Grid2 className={classes.input}>
                  {prodLink ? (
                    <span className={classes.smallText}>
                      <FileDownloadIcon style={{ fontSize: '20px', marginRight: '4px' }} />
                      <a href={prodLink} target="_blank" rel="noreferrer" aria-disabled style={{ color: '#DE5852' }}>
                        {prodLink}
                      </a>
                      <CloseIcon
                        className={classes.close}
                        style={{ fontSize: '20px', marginRight: '4px' }}
                        onClick={() => setProdLink('')}
                      />
                    </span>
                  ) : (
                    <input
                      {...register('productionLink', { required: isAdmin ? true : false })}
                      name="productionLink"
                      id="productionLink"
                      readOnly={isContentSpecialist}
                      style={{ paddingLeft: '14px', height: '40px !important' }}
                      className={`form-control ${errors.productionLink && 'is-invalid'}`}
                      onChange={(e) => handleProdLinkChange(e)}
                    />
                  )}
                </Grid2>
                {isEmpty(getValues('productionLink') || prodLink) && isFormSubmitted && isAdmin && (
                  <span className={`${classes.smallText} ${classes.error}`}>Production File link can not be empty</span>
                )}
              </Grid2>

              <Grid2 container>
                <Grid2 container direction="column" className={classes.inputField} style={{ margin: '11px 0 11px 0' }}>
                  <label>Topic*</label>
                  <Stack spacing={1}>
                    <Autocomplete
                      options={topicList || []}
                      getOptionLabel={(option) => option.name}
                      id="auto-highlight"
                      multiple
                      autoHighlight
                      readOnly={isCreativeEditor}
                      value={selectedTopics}
                      onOpen={() => setOpen(true)}
                      onClose={() => setOpen(false)}
                      popupIcon={
                        open ? (
                          <UpIcon className={classes.dropdownIcon} />
                        ) : (
                          <DownIcon className={classes.dropdownIcon} />
                        )
                      }
                      onChange={handleTopicChange}
                      className={`${classes.field} ${errors.topic && 'is-invalid'}`}
                      renderInput={(params) => <TextField {...params} label="" variant="standard" />}
                    />
                  </Stack>
                  {selectedTopics.length === 0 && isFormSubmitted && isAdmin && (
                    <span className={`${classes.smallText} ${classes.error}`}>Topic can not be empty</span>
                  )}
                </Grid2>

                <Grid2 container direction="column" className={classes.inputField}>
                  <label>Sub-Topic*</label>
                  <Stack spacing={1}>
                    <Autocomplete
                      options={subTopicList || []}
                      getOptionLabel={(option) => option.name}
                      id="auto-highlight"
                      autoHighlight
                      multiple
                      value={selectedSubTopics}
                      onOpen={() => setOpen(true)}
                      onClose={() => setOpen(false)}
                      readOnly={isCreativeEditor}
                      popupIcon={
                        open ? (
                          <UpIcon className={classes.dropdownIcon} />
                        ) : (
                          <DownIcon className={classes.dropdownIcon} />
                        )
                      }
                      onChange={handleSubTopicChange}
                      className={`${classes.field} ${errors.subTopic && 'is-invalid'}`}
                      renderInput={(params) => <TextField {...params} label="" variant="standard" />}
                    />
                  </Stack>
                  {selectedTopics.length === 0 && isFormSubmitted && isAdmin && (
                    <span className={`${classes.smallText} ${classes.error}`}>Sub Topic can not be empty</span>
                  )}
                </Grid2>

                <Grid2 container direction="column" className={classes.inputField}>
                  <label>Brands</label>
                  <Stack spacing={1}>
                    <Autocomplete
                      options={brands || []}
                      getOptionLabel={(option) => option.name}
                      id="auto-highlight"
                      autoHighlight
                      multiple
                      value={selectedBrands}
                      onOpen={() => setOpen(true)}
                      onClose={() => setOpen(false)}
                      popupIcon={
                        open ? (
                          <UpIcon className={classes.dropdownIcon} />
                        ) : (
                          <DownIcon className={classes.dropdownIcon} />
                        )
                      }
                      onChange={handleBrandChange}
                      className={classes.field}
                      readOnly={isCreativeEditor}
                      renderInput={(params) => <TextField {...params} label="" variant="standard" />}
                    />
                  </Stack>
                </Grid2>

                <Grid2 container direction="column" className={classes.inputField}>
                  <label>Persons</label>
                  <Stack spacing={1}>
                    <Autocomplete
                      options={persons || []}
                      getOptionLabel={(option) => option.name}
                      id="auto-highlight"
                      autoHighlight
                      multiple
                      className={classes.field}
                      onOpen={() => setOpen(true)}
                      onClose={() => setOpen(false)}
                      popupIcon={
                        open ? (
                          <UpIcon className={classes.dropdownIcon} />
                        ) : (
                          <DownIcon className={classes.dropdownIcon} />
                        )
                      }
                      value={selectedPersons}
                      onChange={handlePersonChange}
                      readOnly={isCreativeEditor}
                      renderInput={(params) => <TextField {...params} label="" variant="standard" />}
                    />
                  </Stack>
                </Grid2>
              </Grid2>

              <Grid2 container>
                <Grid2 container direction="column" className={classes.inputField} style={{ margin: '11px 0 11px 0' }}>
                  <label>Identity</label>
                  <Stack spacing={1}>
                    <Autocomplete
                      options={identityList || []}
                      getOptionLabel={(option) => option.name}
                      id="auto-highlight"
                      autoHighlight
                      multiple
                      className={classes.field}
                      value={selectedIdentities}
                      onOpen={() => setOpen(true)}
                      onClose={() => setOpen(false)}
                      popupIcon={
                        open ? (
                          <UpIcon className={classes.dropdownIcon} />
                        ) : (
                          <DownIcon className={classes.dropdownIcon} />
                        )
                      }
                      onChange={handleIdentityChange}
                      readOnly={isCreativeEditor}
                      renderInput={(params) => <TextField {...params} label="" variant="standard" />}
                    />
                  </Stack>
                </Grid2>
                <Grid2 container direction="column" className={classes.inputField}>
                  <label>Location</label>
                  <Stack spacing={1}>
                    <Autocomplete
                      options={locations || []}
                      getOptionLabel={(option) => option.name}
                      id="auto-highlight"
                      autoHighlight
                      multiple
                      className={classes.field}
                      onOpen={() => setOpen(true)}
                      onClose={() => setOpen(false)}
                      popupIcon={
                        open ? (
                          <UpIcon className={classes.dropdownIcon} />
                        ) : (
                          <DownIcon className={classes.dropdownIcon} />
                        )
                      }
                      value={selectedLocations}
                      onChange={handleLocationChange}
                      readOnly={isCreativeEditor}
                      renderInput={(params) => <TextField {...params} label="" variant="standard" />}
                    />
                  </Stack>
                </Grid2>
                <Grid2 container direction="column" className={classes.inputField}>
                  <label>Events</label>
                  <Stack spacing={1}>
                    <Autocomplete
                      options={events || []}
                      getOptionLabel={(option) => option.name}
                      id="auto-highlight"
                      multiple
                      className={classes.field}
                      value={selectedEvents}
                      onOpen={() => setOpen(true)}
                      onClose={() => setOpen(false)}
                      popupIcon={
                        open ? (
                          <UpIcon className={classes.dropdownIcon} />
                        ) : (
                          <DownIcon className={classes.dropdownIcon} />
                        )
                      }
                      autoHighlight
                      onChange={handleEventChange}
                      readOnly={isCreativeEditor}
                      renderInput={(params) => <TextField {...params} label="" variant="standard" />}
                    />
                  </Stack>
                </Grid2>
                <Grid2 container direction="column" className={classes.inputField}>
                  <label>Author</label>
                  <Stack spacing={1}>
                    <Autocomplete
                      options={authors || []}
                      getOptionLabel={(option) => option.name}
                      id="auto-highlight"
                      autoHighlight
                      multiple
                      className={classes.field}
                      onOpen={() => setOpen(true)}
                      onClose={() => setOpen(false)}
                      popupIcon={
                        open ? (
                          <UpIcon className={classes.dropdownIcon} />
                        ) : (
                          <DownIcon className={classes.dropdownIcon} />
                        )
                      }
                      value={selectedAuthors}
                      onChange={handleAuthorChange}
                      readOnly={isCreativeEditor}
                      renderInput={(params) => <TextField {...params} label="" variant="standard" />}
                    />
                  </Stack>
                </Grid2>
              </Grid2>

              <Grid2 container direction="column" mt={1.5}>
                <label>Pre-Final File Breadcrumb</label>
                <FormControl fullWidth sx={{ wordBreak: 'break-word', whiteSpace: 'normal' }}>
                  <TextField
                    placeholder="breadcrumb"
                    value={cont?.pathLink}
                    variant="outlined"
                    multiline
                    fullWidth
                    InputProps={{
                      readOnly: true,
                    }}
                    minRows={2}
                    maxRows={4}
                    sx={{ height: 'auto', wordBreak: 'break-word' }}
                    className={classes.outlineInputField}
                  />
                </FormControl>
              </Grid2>

              <Grid2 container direction="column" mt={3}>
                <label>Pre-Final File Path</label>
                <Grid2 container mt={1} className={classes.path} p={0.5}>
                  {cont && (
                    <a
                      href={cont.videoUrl.includes('localhost') ? contentAccessLink : getAccessLink(cont.videoUrl)}
                      target="_blank"
                      rel="noreferrer"
                      style={{ color: '#DE5852', textDecoration: 'none' }}
                      className={classes.overflow}
                    >
                      {cont?.videoUrl}
                    </a>
                  )}
                </Grid2>
              </Grid2>
            </Grid2>

            <Grid2 container justifyContent="flex-end" mt={3} mb={2}>
              <Button
                size="small"
                variant="text"
                type="button"
                onClick={() => setOpenDetailsModal(false)}
                className={classes.cancel}
              >
                cancel
              </Button>
              <Button
                size="small"
                color="primary"
                variant="contained"
                className={`${classes.editDetails} ${(!isEmpty(errors) || disableEdit) ? 'disable' : ''}`}
                type="submit"
                disabled={disableEdit}
              >
                <div className="caption" style={{ fontSize: 'h5', textTransform: 'none' }}>
                  Save Changes
                </div>
              </Button>
            </Grid2>
          </form>
        </DialogContent>
      </Dialog>

      {showConfirmationModal && (
        <ConfirmationDialog action="rename" confirm={handleConfirm} setShowAlert={setShowConfirmationModal} />
      )}
    </>
  );
};

export default PreFinalFileContentDetails;
